// Emergency Service Conversion Page
// Fires when customers call for emergency service

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const EmergencySuccess = () => {
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source') || 'emergency_call';
  const issue = searchParams.get('issue') || 'emergency';

  useEffect(() => {
    // Fire Google Ads conversion tracking (exact snippet) - Higher value for emergency
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-17180193668/94BoCOChwNkaEITnk4BA'});
    }

    // Page title handled by static generation
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Emergency plumbing service dispatched. Colorado First Plumbing is responding to your emergency call.');
    }

    // Add noindex meta tag for crawl budget protection
    const existingNoIndex = document.querySelector('meta[name="robots"]');
    if (!existingNoIndex) {
      const noIndexMeta = document.createElement('meta');
      noIndexMeta.name = 'robots';
      noIndexMeta.content = 'noindex, nofollow';
      document.head.appendChild(noIndexMeta);
    }
  }, [source, issue]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-action-urgent/10 to-neutral-light">
      <Header />
      
      <main className="pt-32 pb-16">
        <div className="container-custom text-center">
          <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-xl p-8 border border-action-urgent/20">
            {/* Emergency Icon */}
            <div className="w-20 h-20 bg-action-urgent rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L5.402 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
            </div>
            
            {/* Emergency Response Message */}
            <h1 className="text-3xl md:text-4xl font-bold text-action-urgent mb-4">
              Emergency Service Dispatched!
            </h1>
            
            <p className="text-xl text-authority-dark mb-6">
              We've received your emergency call. A licensed plumber is being dispatched to your location.
            </p>
            
            {/* Emergency Status */}
            <div className="bg-action-urgent/10 border border-action-urgent/20 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-action-urgent mb-3">🚨 Emergency Response Status:</h3>
              <div className="space-y-2 text-left">
                <p className="text-authority-dark flex items-center">
                  <span className="w-3 h-3 bg-success-primary rounded-full mr-3 animate-pulse"></span>
                  <strong>Call Received:</strong> Emergency logged and prioritized
                </p>
                <p className="text-authority-dark flex items-center">
                  <span className="w-3 h-3 bg-action-primary rounded-full mr-3 animate-pulse"></span>
                  <strong>Plumber Dispatched:</strong> En route to your location
                </p>
                <p className="text-authority-dark flex items-center">
                  <span className="w-3 h-3 bg-neutral-gray rounded-full mr-3"></span>
                  <strong>Estimated Arrival:</strong> Within 2 hours (we'll call with update)
                </p>
              </div>
            </div>
            
            {/* Contact Information */}
            <div className="bg-trust-light border border-trust-primary/20 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-trust-deep mb-2">Stay In Touch</h3>
              <div className="space-y-2">
                <p className="text-authority-dark">
                  <strong>Direct Emergency Line:</strong>
                </p>
                
                <p className="text-sm text-authority-dark mt-2">
                  We'll call you with arrival updates. Please keep your phone available.
                </p>
              </div>
            </div>
            
            {/* Emergency Tips */}
            <div className="bg-neutral-light border border-neutral-border rounded-lg p-6 mb-6 text-left">
              <h3 className="font-bold text-authority-navy mb-3">While You Wait - Emergency Tips:</h3>
              <ul className="space-y-2 text-authority-dark text-sm">
                <li>🔧 <strong>Shut off main water:</strong> If flooding, turn off water at the meter</li>
                <li>⚡ <strong>Electrical safety:</strong> Turn off electricity near water leaks</li>
                <li>📸 <strong>Document damage:</strong> Take photos for insurance if needed</li>
                <li>🧽 <strong>Contain water:</strong> Use towels, buckets to minimize damage</li>
                <li>☎️ <strong>Stay available:</strong> Our plumber will call before arriving</li>
              </ul>
            </div>
            
            {/* Navigation */}
            <div className="space-y-4">
              <a 
                href="/" 
                className="text-authority-dark hover:text-trust-primary transition-colors"
              >
                ← Return to Homepage
              </a>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default EmergencySuccess;